import React from "react";
import { SuperadminBillsContext } from "./context";
import { useResponsive } from "hooks/use-responsive";
import { connect } from "react-redux";
import { usePopupMessages } from "hooks/use-popup-messages";
import { useStateManager } from "hooks/use-state-manager";
import { newRandomListKey } from "../../../services/utils";

const SuperadminBillsState = ({ children }) => {
  const viewport = useResponsive();
  const initialState = {
    fiscalForm: {
      billing_fiscal_id: "",
      alias: "",
      name: "",
      address: "",
      email: "",
      phone: "",
      currency: "VES",
      doc_id: "",
      doc_type: "",
      save_billing_fiscal_info: false,
      apply_igtf: false,
      igtf_percentage: 3,
      has_third_part: false,
      send_branch_office_info: false,
      branch_office: "",
      branch_office_address: "",
    },
    lines: [
      {
        id: newRandomListKey(),
        name: "operation",
        description: "",
        qty: 0,
        amount_bs: 0,
        amount_usd: 0,
        is_exempt: false,
        code: "",
        isActive: true,
        is_third_part: false,
        third_part_doc_id: "",
        third_part_doc_type: "",
        third_part_name: "",
      },
    ],
    showNextPage: false,
    nextPageExist: false,
    currentPage: 1,
    directory: [],
    selectedFiscal: null,
    exchange_usd_to_bs: "",
    currentExchange: 0,
    cleanUp: true,
    showFormOnMobile: false,
    showPreview: false,
    billToPreview: null,
    resetDirectory: true,
  };
  const [state, changeState] = useStateManager(initialState);

  const {
    popupMessages,
    popupMessagesType,
    showPopup,
    throwPopupMessage,
    closePopup,
  } = usePopupMessages(
    "Unidigital tarda de 3 a 5 min en generar un número de control después de generar la factura, por favor sé paciente",
    "alert",
    true
  );

  return (
    <SuperadminBillsContext.Provider
      value={{
        viewport,
        state,
        changeState,
        popupMessages,
        popupMessagesType,
        showPopup,
        throwPopupMessage,
        closePopup,
      }}
    >
      {children}
    </SuperadminBillsContext.Provider>
  );
};

const mapStateToProps = null;
const mapDispatchToProps = null;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SuperadminBillsState);
